import Papa from "papaparse";
import { generateClient } from "aws-amplify/api";
import { uploadFromCSVLambda } from "../graphql/mutations";
import { Project } from "db/definitions";

/**
 * Handles uploading a bunch of prepopulated form groups from CSV file.
 * These have to be setup properly according to our docs or they will not work.
 * This is gonna parse out the csv and send the data to be created as form groups
 * The first row is always going to be the functional row and will contain ids i = 0
 * Second row is for readability for the users to set these up, and has no functionality here
 * The remainder are the rows of data to be prepopulated.
 * @param {CSV} data to be uploaded
 */
async function handleUploadFromCsv(data: string, project: Project) {
	try {
		const results = Papa.parse(data);
		const csvStringifiedArray = JSON.stringify(results.data);
		const client = generateClient({ authMode: "userPool" });
		const deleted = await client.graphql({
			query: uploadFromCSVLambda,
			authMode: "userPool",
			variables: {
				projectId: project.id,
				csvStringifiedArray,
			},
		});
		return deleted;
	} catch (error) {
		console.error("Error uploading from csv: ", error);
	}
}

export default handleUploadFromCsv;
